import React, { useEffect, useState, useRef } from 'react';

import MonthList from './MonthList/MonthList';
import { useDispatch } from 'react-redux';
import { getNearbyMonths, dateToYYYYMMDD } from '../../../helpers/datetime';
import { setPeriodAction } from '../../../store/scheduleReducer';

import "./MonthSelector.scss"

const months = [
	{ 0: 'январь' },
	{ 0: 'февраль' },
	{ 0: 'март' },
	{ 0: 'апрель' },
	{ 0: 'май' },
	{ 0: 'июнь' },
	{ 0: 'июль' },
	{ 0: 'август' },
	{ 0: 'сентябрь' },
	{ 0: 'октябрь' },
	{ 0: 'ноябрь' },
	{ 0: 'декабрь' }
];

const MonthSelector = () => {
	const dropdown = useRef();
	const dispatch = useDispatch()
	const [open, setOpen] = useState(false);
	const [value, setValue] = useState('');
	const [periodValue, setPeriodValue] = useState([]);

	useEffect(() => {
		setTimeout(() => {
			document.addEventListener('click', documentClickHandlerDropdown);
		}, [0])

		return () => document.removeEventListener('click', documentClickHandlerDropdown);
	}, []);

	// закрывает дропдаун
	const documentClickHandlerDropdown = (e) => {
		if (!dropdown.current) return;
		if (!dropdown.current.contains(e.target)) {
			setOpen(false)
		}
	};

	// обновляет месяц в графике
	const updatePeriod = (month) => {
		if (!month) return;

		const [monthName, year] = month.split(' ');
		const monthIndex = months.findIndex(m =>
			m[0].charAt(0).toUpperCase() + m[0].slice(1) === monthName
		);

		if (monthIndex === -1) return;

		let startDate = new Date(year, monthIndex, 1);
		const endDate = new Date(year, monthIndex + 1, 0);

		const formattedStart = dateToYYYYMMDD(startDate);
		const formattedEnd = dateToYYYYMMDD(endDate);

		const periodArray = [formattedStart, formattedEnd];
		dispatch(setPeriodAction(periodArray));

		return periodArray;
	};

	useEffect(() => {
		const date = new Date();
		const months = getNearbyMonths(date);
		setPeriodValue(months);
		setValue(months[6]);
		updatePeriod(months[6]);
	}, []);

	const handleMonthSelect = (month) => {
		updatePeriod(month);
		setValue(month);
		setOpen(false);
	};
	return (
		<div className={"period-selector" + (open ? " open" : "")} ref={dropdown}>
			<button className="period-selector__btn" onClick={() => setOpen(!open)}>{value}</button>
			<div className="period-selector__dropdown">
				<MonthList
					period={periodValue}
					onSelectMonth={handleMonthSelect}
					selectedMonth={value}
				/>
			</div>
		</div>
	);
};

export default MonthSelector;
